// confirmed,unconfirm,cancelled,modified

export const StatusTypes = [
    { value: 'confirmed', label: 'Confirmed' },
    { value: 'unconfirm', label: 'Unconfirmed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'modified', label: 'Modified' },
]

export type StatusType = typeof StatusTypes[number]['value']